function getDefaultQuantity(mixedQuantity) {
    return mixedQuantity > 4 ? 4 : mixedQuantity;
}

export default getDefaultQuantity;
